module.exports = __webpack_public_path__ + "img/city (6).9a32ae15.png";